import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Switch from 'components/switch';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { ProjectedPaymentsForm } from '../services';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  addDescField: {
    marginLeft: theme.spacing(3),
    '&>*': {
      height: theme.spacing(4),
      width: theme.spacing(30),
    }
  },
  cell: {
    paddingTop: theme.spacing(0.2),
    paddingBottom: theme.spacing(0.2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& .MuiFormControlLabel-label': { marginLeft: theme.spacing(2) },
    '& .MuiSwitch-root:has(.MuiSwitch-switchBase.Mui-focusVisible)': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 0,
      borderRadius: 19,
    },
    '@media (hover: none) and (pointer: coarse)': { minHeight: 44, '& .MuiFormControlLabel-root': { minHeight: 44 } },
  }
}));

type InEscrowFieldsTypes = {
  methods: UseFormReturn<ProjectedPaymentsForm>
};

const InEscrowFields = ({
  methods
}: InEscrowFieldsTypes) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { watch, control } = methods;
  const [escrowHomeOwners, escrowTaxes, escrowOthers] = watch(['includes_homeowners', 'includes_taxes', 'includes_other']);
  return (
    <>

      {(!escrowHomeOwners
        && !escrowTaxes
        && !escrowOthers) &&
        <Typography variant="body1">{t('projectedPayments:escrowInfoMessage')}</Typography>}
      {escrowTaxes && (
        <span className={classes.root}>
          <Controller
            control={control}
            name="escrow_taxes"
            render={({ field }) => (
              <Box className={classes.cell}>
                <Switch
                  label={t('projectedPayments:propertiesTaxes')}
                  checked={field.value}
                  handleOnChange={(e) => field.onChange(e.target.checked)}
                />
              </Box>)}
          />
        </span>
      )}
      {escrowHomeOwners && (
        <span className={classes.root}>
          <Controller
            control={control}
            name="escrow_homeowners"
            render={({ field }) => (
              <Box className={classes.cell}>
                <Switch
                  label={t('projectedPayments:homeownersInsurance')}
                  checked={field.value}
                  handleOnChange={(e) => field.onChange(e.target.checked)}
                />
              </Box>
            )}
          />

        </span>
      )}
      {escrowOthers && (
        <span className={classes.root}>
          <Controller
            control={control}
            name="escrow_other"
            render={({ field }) => (
              <Box className={classes.cell}>
                <Switch
                  label={t('projectedPayments:other')}
                  checked={field.value}
                  handleOnChange={(e) => field.onChange(e.target.checked)}
                />
              </Box>)}
          />
        </span>
      )}
    </>
  );
};

export default InEscrowFields;
